import React from 'react';
const modules = [{
  num: '1',
  title: 'Client Assessment System™',
  description: 'Professional intake forms, nutrition assessment templates, medical history questionnaires, lifestyle evaluations, food habit assessments, SMART goal-setting tools, and consultation checklists—everything you need to perform comprehensive client evaluations with confidence.'
}, {
  num: '2',
  title: 'Nutrition Plan Builder™',
  description: 'A complete collection of ready-to-use meal planning templates, weekly nutrition frameworks, portion planning systems, macronutrient distribution guides, personalized planning layouts, and structured nutrition plan builders designed to dramatically reduce planning time.'
}, {
  num: '3',
  title: 'Patient Education Library™',
  description: 'A professional library of printable educational resources including healthy eating guides, food label explanations, hydration resources, grocery shopping guides, portion control materials, nutrient education sheets, and lifestyle improvement handouts ready to share with every client.'
}, {
  num: '4',
  title: 'Consultation Resource Library™',
  description: 'Ready-to-use consultation worksheets, nutrition coaching activities, behavior change exercises, motivation worksheets, reflection journals, visual portion guides, goal review templates, and practical clinical resources to improve every consultation.'
}, {
  num: '5',
  title: 'Client Progress Tracker™',
  description: 'Professional tracking systems including food journals, habit trackers, body measurement logs, weekly check-in forms, follow-up consultation templates, compliance monitoring tools, progress evaluation sheets, and long-term client monitoring resources.'
}, {
  num: '6',
  title: 'Professional Practice Toolkit™',
  description: 'Complete practice management resources including consultation workflows, appointment organization systems, documentation templates, administrative forms, productivity checklists, client file organization tools, and professional resources to simplify your daily workflow.'
}];
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/tNUwkuWAd2acQyqjdygdXd/ChatGPT-Image-2-jul-2026_-08_17_03-p.m..webp';
export function TomiSection() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <div className="text-center mb-6" data-id="element-185">
          <p className="text-sm font-extrabold text-brand-gold uppercase tracking-widest mb-1" data-id="element-186">
            THE SOLUTION YOU'VE BEEN LOOKING FOR
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-1 uppercase leading-tight" data-id="element-187">
            ONE COMPLETE 6-IN-1 PROFESSIONAL NUTRITION SYSTEM
          </h2>
          <p className="text-base font-bold text-brand-rose mb-3" data-id="element-188">
            6 Professional Modules In One Complete Nutrition System
          </p>
          <div className="inline-block bg-brand-petrol text-white px-4 py-1.5 rounded-md mb-3 shadow-md" data-id="element-189">
            <p className="font-bold text-sm sm:text-base tracking-wide" data-id="element-190">
              🥗 NUTRITIONIST PRO™ — 6-in-1 System
            </p>
          </div>
          <p className="text-base text-brand-graphite/90 font-medium max-w-3xl mx-auto leading-snug" data-id="element-191">
            Nutritionist Pro™ is much more than a collection of meal plans and
            templates. It's a complete professional system designed to help
            nutritionists assess clients more efficiently, create personalized
            nutrition plans faster, organize consultations with confidence,
            simplify client follow-ups, and deliver a more professional
            nutrition experience every single day.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-192">
          {modules.map((module, i) => <a href="#pricing" key={i} className="bg-white border-2 border-brand-gold/40 p-3 rounded-lg flex gap-3 items-start shadow-sm hover:border-brand-petrol transition-colors cursor-pointer" data-id="element-193">
              <div className="bg-brand-petrol text-white font-bold px-2.5 py-1.5 rounded text-xs shrink-0 tracking-wider" data-id="element-194">
                {module.num}
              </div>
              <div data-id="element-195">
                <h3 className="text-sm sm:text-base font-bold text-brand-graphite leading-tight" data-id="element-196">
                  ✅ {module.title}
                </h3>
                <p className="text-brand-graphite/70 text-xs sm:text-sm font-medium mt-0.5 leading-snug" data-id="element-197">
                  {module.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-6 text-center" data-id="element-198">
          <a href="#pricing" className="inline-block cursor-pointer" data-id="element-199">
            <img src={PRODUCT_IMG} alt="Nutritionist Pro 6-in-1 System" className="w-full max-w-xs mx-auto object-contain drop-shadow-xl hover:scale-[1.03] transition-transform duration-300" data-id="element-200" />
          </a>
        </div>
      </div>
    </section>;
}